<template>
  <b-card>
    <!-- User Info: Left col -->
    <b-row>
      <b-col lg="12" class="d-flex justify-content-between flex-column">
        <!-- User Avatar & Action Buttons -->
        <div class="d-flex justify-content-start">
          <b-avatar rounded size="42" :src="userData.profile_image_path" />

          <div class="d-flex flex-column ml-1">
            <div class="mb-1">
              <h4 class="mb-0">
                {{ userData.full_name }}
              </h4>
              <span class="card-text">{{ userData.email }}</span>
            </div>
            <div class="d-flex flex-wrap">
              <!-- <b-button
                :to="{ name: 'apps-users-edit', params: { id: userData.id } }"
                variant="primary"
              >
                Edit
              </b-button>
              <b-button
                variant="outline-danger"
                class="ml-1"
              >
                Delete
              </b-button> -->
            </div>
          </div>
        </div>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <!-- Right Col: Table -->
      <b-col lg="12">
        <table class="mt-2 mt-xl-0 w-100">
          <tr>
            <th class="pb-50">
              <feather-icon icon="UserIcon" class="mr-75" />
              <span class="font-weight-bold">الاسم الأول</span>
            </th>
            <td class="pb-50">
              {{ userData.first_name }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="UserIcon" class="mr-75" />
              <span class="font-weight-bold">اسم العائلة</span>
            </th>
            <td class="pb-50">
              {{ userData.last_name }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="CheckIcon" class="mr-75" />
              <span class="font-weight-bold">حالة</span>
            </th>
            <td class="pb-50 text-capitalize">
              <feather-icon icon="CheckIcon" class="mr-75" />
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="StarIcon" class="mr-75" />
              <span class="font-weight-bold">الوظيفة</span>
            </th>
            <td class="pb-50 text-capitalize">
              {{ userData.account_type }}
            </td>
          </tr>
          <tr>
            <th class="pb-50">
              <feather-icon icon="FlagIcon" class="mr-75" />
              <span class="font-weight-bold">البلد</span>
            </th>
            <td class="pb-50">
              {{ userData.country_id }}
            </td>
          </tr>
          <tr>
            <th>
              <feather-icon icon="PhoneIcon" class="mr-75" />
              <span class="font-weight-bold">التليفون المحمول</span>
            </th>
            <td>
            {{    userData.mobile + " " + userData.country.phone_code + "+" }}
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
    <template  v-if="userData.account_type=='teacher'">
    <hr />
    <b-row >
      <b-col col="12">
        <b-button
          block
          variant="relief-info"
          target="_blank"
          :href="userData.profile_cv_path"
        >
         {{$t('users.cv')}}
        </b-button>
      </b-col>
    </b-row>
    </template>
    <template v-if="isOwnProfile">
      <hr />
      <b-row>
        <b-col col="12">
          <b-button
            block
            variant="outline-danger"
            :to="{ name: 'deleteAccount' }"
          >
            <feather-icon icon="Trash2Icon" class="mr-50" />
            مسح الحساب
          </b-button>
        </b-col>
      </b-row>
    </template>
  </b-card>
</template>

<script>
import { BCard, BButton, BAvatar, BRow, BCol } from "bootstrap-vue";

export default {
  components: {
    BCard,
    BButton,
    BRow,
    BCol,
    BAvatar,
  },
  props: {
    userData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isOwnProfile() {
      return !this.$route.params.id;
    },
  },
};
</script>

<style>
</style>
